export default __webpack_public_path__ + "static/media/sv11_en_jing_b3.38b26d0a.mp3";